var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContrast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.66 5.93002L8 0.27002L2.34 5.93002C-0.78 9.05002 -0.78 14.12 2.34 17.24C3.9 18.8 5.95 19.58 8 19.58C10.05 19.58 12.1 18.8 13.66 17.24C16.78 14.12 16.78 9.05002 13.66 5.93002ZM8 17.59C6.4 17.59 4.89 16.97 3.76 15.83C2.62 14.69 2 13.19 2 11.59C2 9.99002 2.62 8.48002 3.76 7.35002L8 3.10002V17.59Z",
    fill: "#010101"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrast);
export default __webpack_public_path__ + "static/media/contrast.5c80c2f9764ff15f8cafbc717edffe1a.svg";
export { ForwardRef as ReactComponent };